// Importaciones de React y componentes de FontAwesome para los iconos.
import React from 'react';
import { Link } from 'react-router-dom'; // Importa Link para la navegación interna.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Componente para renderizar iconos de FontAwesome.
import { faFacebook, faLinkedin } from '@fortawesome/free-brands-svg-icons'; // Iconos específicos de redes sociales.
import logo from '../logos/LOGOS DS CYBER-07.png'; // Logotipo de la empresa.

/**
 * Componente del pie de página (Footer).
 * Muestra información de la empresa, enlaces de navegación, redes sociales y el copyright.
 */
export const Footer = () => {
  return (
    // Contenedor principal del footer con un fondo degradado.
    <footer className="bg-gradient-to-r from-blue-900 to-blue-800 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Rejilla principal que organiza el contenido en columnas. Es adaptable (responsive). */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 text-center md:text-left">

          {/* Columna 1: Logo y eslogan. */}
          <div className="space-y-4">
            <img className='h-20 mx-auto md:mx-0 transition-transform hover:scale-105' src={logo} alt="Logo de DS Cyber" />
            <div className="space-y-2 text-gray-300">
              <p className="hover:text-white transition-colors">Opera eficientemente</p>
              <p className="hover:text-white transition-colors">Máximiza la inversión</p>
              <p className="hover:text-white transition-colors">Reduce riesgos.</p>
            </div>
          </div>

          {/* Columna 2: Enlaces de "Nosotros". */}
          <div className="space-y-4">
            <h4 className="font-bold text-xl mb-4 text-blue-200">Nosotros</h4>
            <nav className="space-y-3">
              {/* NOTA: Estos son elementos <p> y no enlaces <a>. No navegan. */}
              <p className="hover:text-blue-200 transition-colors cursor-pointer">La empresa</p>
              <p className="hover:text-blue-200 transition-colors cursor-pointer">Propuesta de valor</p>
              <Link to="/privacidad" className="block hover:text-blue-200 transition-colors cursor-pointer">Política de Privacidad</Link>
            </nav>
          </div>

          {/* Columna 3: Enlaces de "Productos". */}
          <div className="space-y-4">
            <h4 className="font-bold text-xl mb-4 text-blue-200">Productos</h4>
            <nav className="space-y-3">
              <p className="hover:text-blue-200 transition-colors cursor-pointer">DSeCOps</p>
              <p className="hover:text-blue-200 transition-colors cursor-pointer">Ciberconciencia</p>
              <p className="hover:text-blue-200 transition-colors cursor-pointer">Validación de controles</p>
              <p className="hover:text-blue-200 transition-colors cursor-pointer">Protección de datos</p>
              <p className="hover:text-blue-200 transition-colors cursor-pointer">Threat Hunting</p>
              <p className="hover:text-blue-200 transition-colors cursor-pointer">Ciberinteligencia accionable</p>
            </nav>
          </div>

          {/* Columna 4: Enlaces de "Servicios". */}
          <div className="space-y-4">
            <h4 className="font-bold text-xl mb-4 text-blue-200">Servicios</h4>
            <nav className="space-y-3">
              <p className="hover:text-blue-200 transition-colors cursor-pointer">Consultoría especializada</p>
              <p className="hover:text-blue-200 transition-colors cursor-pointer">Certificación</p>
              <p className="hover:text-blue-200 transition-colors cursor-pointer">Servicio de CISO</p>
              <p className="hover:text-blue-200 transition-colors cursor-pointer">Certificación ISO27001</p>
              <p className="hover:text-blue-200 transition-colors cursor-pointer">Certificación ISO22301</p>
            </nav>
          </div>
        </div>

        {/* Sección inferior del footer con línea divisoria, redes sociales y copyright. */}
        <div className="border-t border-blue-700/50 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">

            {/* Iconos de redes sociales con enlaces externos. */}
            <div className="flex justify-center space-x-6">
              <a href="https://www.facebook.com/dscyber.io/"
                target="_blank" // Abre el enlace en una nueva pestaña.
                rel="noopener noreferrer" // Medida de seguridad para enlaces externos.
                className="hover:text-blue-300 transition-colors">
                <FontAwesomeIcon icon={faFacebook} size="2x" />
              </a>
              <a href="https://www.linkedin.com/company/dscyber/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-300 transition-colors">
                <FontAwesomeIcon icon={faLinkedin} size="2x" />
              </a>
            </div>

            {/* Texto de Copyright. El año se genera dinámicamente. */}
            <p className="text-gray-300 text-sm">
              Copyright © {new Date().getFullYear()} DS cyber - All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

// Exporta el componente para su uso en otras partes de la aplicación.
export default Footer;
